package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.game.ActorState
import xim.poc.game.StatusEffect
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.*
import xim.poc.game.configuration.v0.tactics.TacticsInstincts
import xim.poc.game.configuration.v0.tactics.addInstinct
import xim.poc.game.configuration.v0.tactics.getUnit
import xim.poc.game.event.Event

class TacticsCarbuncleBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    override fun getSelectableSkills(): List<SkillId> {
        return if (wantsToAstralFlow() && isDisplayCharging()) {
            listOf(mskillSearingLight_656)
        } else {
            super.getSelectableSkills() - mskillSearingLight_656
        }
    }

    override fun onSkillExecutedScoped(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (wantsToAstralFlow()) { displayCharging(primaryTargetContext.context) }
        if (primaryTargetContext.skill == mskillSearingLight_656) { endCharging() }
        return emptyList()
    }

    private fun wantsToAstralFlow(): Boolean {
        return !hasUsedSkill(mskillSearingLight_656) && actorState.getHpp() < 0.5f
    }

}

class TacticsSupportCarbuncleBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    override fun onBehaviorInitialized(): List<Event> {
        actorState.getUnit().addInstinct(TacticsInstincts.pass, 1)
        actorState.getUnit().addInstinct(TacticsInstincts.move, 1)
        return emptyList()
    }

    override fun getSelectableSkills(): List<SkillId> {
        return if (actorState.getHpp() < 0.5f && !hasUsedSkill(mskillHealingRubyII_655)) {
            listOf(mskillHealingRubyII_655)
        } else {
            getSkills() - mskillHealingRubyII_655
        }
    }

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        val isSupportSkill = query.skill == mskillShiningRuby_652 || query.skill == mskillGlitteringRuby_653

        if (isSupportSkill && query.target.behaviorController is TacticsCarbuncleBehavior) {
            return if (query.skill == mskillShiningRuby_652 && query.target.hasStatusEffect(StatusEffect.Shell)) {
                0f
            } else if (query.skill == mskillGlitteringRuby_653 && query.target.hasStatusEffect(StatusEffect.MagicAtkBoost)) {
                0f
            } else {
                10_000f
            }
        }

        return super.estimateSkillValue(query)
    }

}